/**
 * Created by hieult on 1/11/18.
 */
import * as utils from '../functions/utils';
import { CATEGORY_ID } from '../constants/category';
import { IProperyItem } from 'redhotpie-shared-lib/interfaces/IProperyItem';

export interface IPropertyItemType {
  ItemID: number;
  ListID: number;
  ItemName: string;
  icSrc: string;
  value: any;
}

export default class PropertyItem {
  id: number;
  listId: number;
  value: any;
  active: boolean;
  label: string | null;
  icSrc:
    | {
        active: string;
        noActive: string;
      }
    | string;

  constructor() {
    this.id = -1;
    this.listId = 0;
    this.value = null;
    this.active = false;
    this.label = 'Men';
    this.icSrc = {
      active: '',
      noActive: '',
    };
  }

  static mappingObject(propertyItem: IPropertyItemType, activeId?: number): IProperyItem {
    const _propertyItem = new PropertyItem();
    _propertyItem.id = propertyItem.ItemID;
    _propertyItem.listId = propertyItem.ListID;
    _propertyItem.label = propertyItem.ItemName || '';
    _propertyItem.icSrc = propertyItem.icSrc || '';
    _propertyItem.value = propertyItem.value || null;
    _propertyItem.active = propertyItem.ItemID === activeId;
    return _propertyItem;
  }

  static mappingObjects(propertyItems: IPropertyItemType[], categoryId?: string, activeId?: number): IProperyItem[] {
    const _propertyItems: IProperyItem[] = [];
    let idAllMembers = 0;
    if (categoryId !== undefined) {
      if (categoryId !== CATEGORY_ID.MS_LOOKING_FOR && categoryId !== CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE && categoryId !== undefined) {
        _propertyItems.push(this.objectDefault());
      } else {
        if (categoryId !== CATEGORY_ID.MS_LOOKING_FOR) {
          _propertyItems.push(this.objectAllMember());
        }
      }
    }
    propertyItems.forEach(property => {
      const _property = PropertyItem.mappingObject(property, activeId);
      _propertyItems.push(_property);
      idAllMembers += property.ItemID;
    });
    if (categoryId !== undefined && categoryId === CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE) {
      _propertyItems[0].id = 0;
    }

    return _propertyItems;
  }

  static getIconObjects(categoryId: string, propertyItems: IProperyItem[]): IProperyItem[] {
    const _propertyItems: IProperyItem[] = [];
    propertyItems.forEach(property => {
      const _property = property;
      if (property.label === 'All') {
        _property.icSrc = { active: '', noActive: '' };
      } else {
        _property.icSrc = utils.getIconCategoryItem(categoryId, property.id);
      }
      _propertyItems.push(_property);
    });
    return _propertyItems;
  }

  static convertLabelObjects(categoryId: string, propertyItems: PropertyItem[]): IProperyItem[] {
    const _propertyItems: IProperyItem[] = [];
    propertyItems.forEach(property => {
      const _property = property;
      _property.label = utils.convertLabelCategory(_property.id);
      _propertyItems.push(_property);
    });
    return _propertyItems;
  }

  static objectDefault(): PropertyItem {
    const _propertyItem = new PropertyItem();
    _propertyItem.id = -1;
    _propertyItem.active = true;
    _propertyItem.icSrc = '';
    _propertyItem.label = 'No preference';
    _propertyItem.listId = 0;
    _propertyItem.value = null;

    return _propertyItem;
  }

  static objectAllMember(): PropertyItem {
    const _propertyItem = new PropertyItem();
    _propertyItem.id = -1;
    _propertyItem.listId = 0;
    _propertyItem.label = 'All';
    _propertyItem.icSrc = '';
    _propertyItem.value = null;
    _propertyItem.active = true;
    return _propertyItem;
  }

  static mappingObjectsCategory(_tickets: IPropertyItemType[]): IProperyItem[] {
    const listCategory: PropertyItem[] = [];
    _tickets.forEach(_ticket => {
      const ticket = PropertyItem.mappingObject(_ticket);
      listCategory.push(ticket);
    });
    return listCategory;
  }
}
